import { defineStore } from 'pinia';

export const usePageLoadingStore = defineStore('pageLoading', {
  state: () => ({
    loadedPages: {},
    displayedText: {}
  }),
  actions: {
    setLoaded(key, value) {
        this.loadedPages[key] = value;
    },
    isLoaded(key) {
        return this.loadedPages[key];
    },
    setDisplayedText(key, value) {
        this.displayedText[key] = value;
    },
    getDisplayedText(key) {
        return this.displayedText[key];
    }
  },
});
